import type { IconSvgObject } from './types';

const ArrowMoveLeftDownIcon: IconSvgObject = [
  ["path", { d: "M3 5L16 5.00024C17.1046 5.00026 18 5.89569 18 7.00024V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 2L3 5.00012L6 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 19L18 21.9999L21 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowMoveLeftDownIcon;
